import { kaliciDurumlariTemizle } from './kalici';

/**
 * ETKİN KULLANICI DEĞİŞTİ — istemcide ondan kalan HER ŞEYİ at.
 *
 * ⚠️ TEK YER. Aynı temizlik çıkışta zaten yapılıyordu ama kullanıcı geçişinde
 *    (temsil başlat/bitir) YAPILMIYORDU — oysa etkin kullanıcının değişmesi
 *    açısından ikisi aynı olay. İki yerde ayrı yazılsaydı biri güncellenip
 *    diğeri unutulurdu; nitekim öyle olmuştu.
 *
 * ⚠️ ASIL SORUN SERVICE WORKER ÖNBELLEĞİ, ekrandaki değişkenler değil.
 *    `/api/*` GET'leri `NetworkFirst` + **4 saniye** zaman aşımıyla
 *    önbelleğe alınıyor. Telefonda zayıf sinyalde 4 saniye kolayca doluyor ve
 *    `/islerim` isteği ÖNCEKİ KULLANICININ önbellekteki listesiyle
 *    cevaplanıyor: geçiş sunucuda olmuş, ekran eskiyi göstermeye devam
 *    ediyor. Sahadaki karşılığı — "kullanıcı değiştirildiğinde önceki
 *    kullanıcı bilgisi hatırlanıyor, telefon bekliyor" (07.08.2026).
 *
 * ⚠️ Fotoğraf önbelleği `CacheFirst` — ağa HİÇ gitmez. Temizlenmezse geçilen
 *    kullanıcı, öncekinin görebildiği kanıt fotoğraflarını önbellekten görür.
 *
 * ⚠️ Bu bir YETKİ açığı değildir: sunucuda `ActorContext` zaten hedefin ve
 *    her istek yeniden yetkilendiriliyor. Sızan şey istemcide önbelleğe
 *    alınmış VERİ. Yine de kanıt zinciri söz konusu olduğu için kapatılmalı.
 */
export async function kullaniciDegisti(): Promise<void> {
  kaliciDurumlariTemizle();

  /*
   * Service worker'a mesaj gönderip beklemek yerine önbellekleri DOĞRUDAN
   * siliyoruz: `postMessage` ateşle-unut'tur, silme bitmeden sayfa yeniden
   * yüklenirse eski cevaplar yerinde kalırdı. `caches` API'si sayfadan da
   * erişilebilir ve `await` edilebilir.
   */
  try {
    await Promise.all([caches.delete('mod-api-v1'), caches.delete('mod-foto-v1')]);
  } catch {
    /* Depolama kapalıysa (gizli sekme) yut — geçişin kendisi engellenmemeli. */
  }
  // Service worker kendi tarafında da haberdar olsun (eski sürümlerle uyum).
  navigator.serviceWorker?.controller?.postMessage({ tip: 'onbellegi-temizle' });
}

/**
 * Geçiş sonrası SAYFAYI YENİDEN YÜKLE.
 *
 * ⚠️ Tek tek durum sıfırlamak yerine bilinçli tercih: ekranlarda açık
 *    akordeonlar, doldurulmuş formlar, yüklenmiş listeler ve React Query
 *    benzeri her türlü bellek içi durum yeniden yüklemede kendiliğinden
 *    gider. "Hangi durumu unuttum" sorusunu tamamen ortadan kaldırıyor.
 *
 * ⚠️ OTURUM JETONU DÖNDÜRÜLMEZ. Temsil, VAR OLAN oturumu değiştirir
 *    (`sessions.temsilBaslat(sessionId, …)`) ve iz kaydındaki çift kimlik
 *    buna dayanır: `user_id` temsil edileni, `gercek_kullanici_id` gerçekte
 *    tıklayanı gösterir. Jetonu yenilemek denetim izini karmaşıklaştırır,
 *    güvenliğe bir şey katmaz.
 */
export function bastanYukle(): void {
  window.location.href = '/';
}
